import React, { useEffect, useState } from 'react';
import 'date-fns';
import PropTypes from 'prop-types';
import { CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
import { SelectValidator } from 'react-material-ui-form-validator';
import MenuItem from '@material-ui/core/MenuItem';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import { StatusVisitaFiliado } from '../../../../values/StatusVisitaFiliadoValues';
import { Values } from '../../../../values/Values';
import { getAllFiliados } from '../../../../services/FiliadoService';
import {ptBR} from 'date-fns/locale'
import  DialogFiliadoObservacoes  from '../../../../components/DialogFiliadoObservacoes/DialogFiliadoObservacoes'
moment.locale('pt-BR');


function VisitaFiliadoRegisterDetalhadoPasso1(props) {
  const {
    visitaFiliado,
    setVisitaFiliado,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    filiacaoStatus,
    gruposSanguineos,
    edicao,
    setRefreshStatePai
  } = props;
  const [filiadoSelecionado, setFiliadoSelecionado] = useState(props.visitaFiliado.filiado);
  const [dataEntrada, setDataEntrada] = useState(props.visitaFiliado.dataEntrada);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [filiados, setFiliados] = useState([]);
  const loadingUsers = openAutocomplete && filiados.length === 0;
  const [statusVisita, setStatusVisita] = useState(props.visitaFiliado.visitaEncerrada);
  moment.locale('pt-BR');


  useEffect(() => {
    getFiliados();

  }, []);

  async function getFiliados() {
    try {
      let dados = await getAllFiliados(1000, 1);
      if(dados.isSuccess) {
        setFiliados(dados.result);
      }
      else {
        setTypeSnack('error');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
        setTypeSnack('error');
        setMessageSnack(Values.MessageValues.erro_catch);
        setShowMessageSnack(true);
    }
  }


  const handleChangeDataEntrada = date => {
    visitaFiliado.dataEntrada = moment(date);
    setVisitaFiliado(visitaFiliado);
    setDataEntrada(date);
  };

  function modificarValores(order, value){
    switch (order) {
      case 0:
        visitaFiliado.visitaEncerrada = value;
        setVisitaFiliado(visitaFiliado);
        setStatusVisita(value);
        break;
    }
  }


  function aoModificarFiliado(event, filiado01) {
    if(filiado01){
      setFiliadoSelecionado(filiado01);
      visitaFiliado.idFiliado = filiado01.idFiliado;
      visitaFiliado.filiado = filiado01;
      setVisitaFiliado(visitaFiliado);
      setRefreshStatePai(new Date());
    }

  }

  return (
    <div>
      <CardHeader
        subheader="Informe as seguintes informações do filiado"
        title={edicao ? "Edicao de registro de visita" : "Registro de visita"}
      />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            md={6}
            xs={12}
          >
            <Autocomplete
              size={'small'}
              id="autocomplete_usuario"
              openOnFocus
              value={filiadoSelecionado}
              onChange={aoModificarFiliado}
              getOptionSelected={(option, value) => (option.cpf ? option.cpf : 'Sem CPF')  + ' - ' + option.nome === option.cpf + ' - ' + option.nome}
              getOptionLabel={option => (option.cpf ? option.cpf : 'Sem CPF') + ' - ' + option.nome + ' - ' + (option.codigo ? option.codigo : 'Sem código')}
              options={filiados}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Filiado"
                  fullWidth
                  value={filiadoSelecionado}
                  margin={'dense'}
                  variant="outlined"
                  helperText={'Selecione o filiado associado a essa visita.'}
                />
              )}
            />
          </Grid>
          <Grid
            item
            lg={3}
            md={3}
            xs={12}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
              <Grid container justify="space-around">
                <DateTimePicker
                  fullWidth
                  margin="dense"
                  inputVariant="outlined"
                  id="dataEntrada"
                  label="Data de Entrada"
                  helperText={'Insira a data e hora de entrada do filiado'}
                  format="dd/MM/yyyy HH:mm"
                  size='small'
                  value={dataEntrada}
                  onChange={handleChangeDataEntrada}
                  lang={'pt-BR'}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  InputAdornmentProps={{ position: "end" }}
                />

              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <SelectValidator
              fullWidth
              helperText="Status atual da visita do filiado"
              disabled
              label="Status"
              margin="dense"
              name="status"
              onChange={e => modificarValores(0, e.target.value)}
              value={statusVisita}
              variant="outlined"
              validators={['required']}
              errorMessages={['Status atual da visita do filiado.']}
            >
              {StatusVisitaFiliado.map((status, index) => (
                <MenuItem key={index} value={status.visitaEncerrada}>{status.label}</MenuItem>
              ))}

            </SelectValidator>

          </Grid>
        </Grid>
      </CardContent>
      <Divider />

    </div>
  );
};

VisitaFiliadoRegisterDetalhadoPasso1.propTypes = {
  className: PropTypes.string,
    visitaFiliado: PropTypes.object.isRequired,
  setVisitaFiliado: PropTypes.object.isRequired
};

export default VisitaFiliadoRegisterDetalhadoPasso1;


